const autocompleteModalAction = {
  user: 'Responsáveis',
  helperText: 'Quantidade máxima de responsáveis:',
};

export default autocompleteModalAction;
